import { IApplicationState } from '../../../../types/types';
import { ILists } from '../types';

export const getLists = (
    state: IApplicationState,
): ILists => {
    return state.model.lists;
}
